<template>
  <div
    :class="[`backdrop ${isOpenChangeColorBlock ? 'show-backdrop' : ''}`]"
    @click="$emit('on-backdrop-click')"
  >
    <div
      :class="[
        `payment-info-block ${
          isOpenChangeColorBlock ? 'open-payment-info-block' : ''
        }`,
      ]"
      @click.stop=""
    >
      <div class="create-payment-header-container">
        <div>
          <h2 class="create-payment-title">
            {{ $t("homePage.colorPickerTitle") }}
            <span class="webapp-color">WebApp</span>
          </h2>
          <p class="create-payment-info">
            {{ $t("homePage.colorPicketInstruection") }}
          </p>
        </div>
        <button
          class="create-bayment-close-button"
          @click="$emit('on-backdrop-click')"
        >
          <x-icon class="create-payment-close-icon" />
        </button>
      </div>
      <div class="colors-variants-container">
        <div
          v-for="color of allColors"
          :key="color.id"
          class="color-block-container"
          @click.stop="changeColor(color.id)"
        >
          <div :class="[`color-block ${color.name}`]"></div>
          <p class="color-name">{{ color.name }}</p>
        </div>
      </div>
      <button
        class="close-info-customer-modal"
        @click="$emit('on-backdrop-click')"
      >
        {{ $t("homePage.colorPickerBack") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { XIcon } from "vue-feather-icons";

export default {
  name: "Color-picker-block",
  components: {
    XIcon,
  },
  props: {
    isOpenChangeColorBlock: {
      type: Boolean,
      require: true,
    },
    openedCustomer: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      currencySymbol: {
        1: "₴",
        2: "$",
        4: "€",
        6: "zł",
        7: "₴",
      },
      allColors: [
        { id: 1, name: "Red", color: "#DA4453" },
        { id: 2, name: "Green", color: "#8CC152" },
        { id: 3, name: "Blue", color: "#4A89DC" },
        { id: 4, name: "Mint", color: "#37BC9B" },
        { id: 5, name: "Orange", color: "#E9573F" },
        { id: 6, name: "Yellow", color: "#F6BB42" },
        { id: 7, name: "Magenta", color: "#967ADC" },
        { id: 8, name: "Brown", color: "#AA8E69" },
      ],
    };
  },
  async mounted() {},

  methods: {
    ...mapMutations(["deleteOperationById"]),
    changeColor(id) {
      let page = document.querySelector("#page-body");
      switch (id) {
        case 1:
          window.localStorage.setItem("color", "red-theme");
          page.classList.replace(page.classList.item(1), "red-theme");
          return;
        case 2:
          window.localStorage.setItem("color", "green-theme");
          page.classList.replace(page.classList.item(1), "green-theme");
          return;
        case 3:
          window.localStorage.setItem("color", "standart-theme");
          page.classList.replace(page.classList.item(1), "standart-theme");
          return;
        case 4:
          window.localStorage.setItem("color", "mint-theme");
          page.classList.replace(page.classList.item(1), "mint-theme");
          return;
        case 5:
          window.localStorage.setItem("color", "orange-theme");
          page.classList.replace(page.classList.item(1), "orange-theme");
          return;
        case 6:
          window.localStorage.setItem("color", "yellow-theme");
          page.classList.replace(page.classList.item(1), "yellow-theme");
          return;
        case 7:
          window.localStorage.setItem("color", "magenta-theme");
          page.classList.replace(page.classList.item(1), "magenta-theme");
          return;
        case 8:
          window.localStorage.setItem("color", "brown-theme");
          page.classList.replace(page.classList.item(1), "brown-theme");
          return;
      }
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
.payment-info-block {
  position: absolute;
  width: 95%;
  left: 2.5%;
  bottom: 2.5%;
  padding: 15px;
  padding-top: 80px;
  transform: translateY(110%);
  pointer-events: all !important;
  -webkit-backdrop-filter: saturate(180%) blur(80px);
  backdrop-filter: saturate(180%) blur(80px);
  background-color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  z-index: 9999 !important;
  border: 0px !important;
  border-radius: 20px;
  transition: all 0.5s ease;
}

.open-payment-info-block {
  transform: none;
}

/* ////////////////////////// */

.webapp-color {
  color: var(--secondary-bg-color);
}

.create-payment-header-container {
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.create-payment-title {
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;
  color: #1b1b1b;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: -0.6px;
  margin-bottom: 0px;
}

.create-payment-info {
  margin-bottom: 10px;
  color: #747474;
  letter-spacing: -0.2px;
  font-size: 13px;
  font-family: "Source Sans Pro", sans-serif;
  line-height: 24px;
}

.create-bayment-close-button {
  cursor: pointer;
  background: transparent;
  border: none;
}

.create-payment-close-icon {
  width: 26px;
  height: 26px;
  color: #d84558;
}

.colors-variants-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: flex-start;
  padding-top: 20px;
  padding-bottom: 20px;
  gap: 10px;
}

.color-block-container {
  width: 20%;
  cursor: pointer;
}

.color-block {
  width: 45px;
  height: 45px;
  margin: 0 auto;
  border-radius: 15px;
  transform: translateY(2px);
}

.color-block:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.75) translateY(5px) translateZ(0px);
  filter: blur(8px);
}

.color-block.Red {
  background-image: linear-gradient(to bottom, #ed5565, #d84558);
}
.color-block.Green {
  background-image: linear-gradient(to bottom, #a0d468, #8cc152);
}
.color-block.Blue {
  background-image: linear-gradient(to bottom, #5d9cec, #4a89dc);
}
.color-block.Mint {
  background-image: linear-gradient(to bottom, #48cfad, #37bc9b);
}
.color-block.Orange {
  background-image: linear-gradient(to bottom, #fc6e51, #e9573f);
}
.color-block.Yellow {
  background-image: linear-gradient(to bottom, #ffce54, #f6bb42);
}
.color-block.Magenta {
  background-image: linear-gradient(to bottom, #ac92ec, #967adc);
}
.color-block.Brown {
  background-image: linear-gradient(to bottom, #baa286, #aa8e69);
}

.close-info-customer-modal {
  display: block;
  font-family: "Source Sans Pro", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  background-size: cover;
  position: relative;
  z-index: 10;
  color: #fff;
  width: 100%;
  border: none;
  margin-top: 20px;
  cursor: pointer;
  margin-bottom: 20px;
  background-image: var(--main-bg-color);
}

.close-info-customer-modal::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.8) translateY(5px) translateZ(0px);
  filter: blur(12px);
}

.color-name {
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  color: #1b1b1b;
  font-family: "Source Sans Pro", sans-serif;
  margin-bottom: 5px;
  letter-spacing: -0.6px;
  text-align: center;
  margin-top: 5px;
}
</style>
